import React, { useState, useMemo } from "react";

import { getAllEvents, getAssistantsByEventId } from "services/event.service";
import { useApp } from "context/appContext";

const AdminContext = React.createContext();

export function AdminProvider(props) {
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const [showEventList, setShowEventList] = useState(true);
  const [showAssistantList, setShowAssistantList] = useState(false);
  const [currentEvent, setCurrentEvent] = useState(null);
  const [newEvent, setNewEvent] = useState(true);
  const [assistanList, setAssistantList] = useState([]);
  const { showNotification } = useApp();

  const getEventsInit = async () => {
    setLoading(true);
    let eventsFound = [];
    try {
      eventsFound = await getAllEvents();
      setEvents(eventsFound);
    } catch (err) {
      showNotification("Error en la consulta de eventos", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSelectEvent = (eventId) => {
    const eventSelected = events.find((ev) => ev.id === eventId);
    setNewEvent(false);
    setCurrentEvent(eventSelected);
    setShowAssistantList(false);
    setShowEventList(false);
  };

  const handleSelectAssistantEvent = async (eventId) => {
    setLoading(true);
    try {
      let id = eventId;
      if (id) {
        const eventSelected = events.find((ev) => ev.id === eventId);
        setCurrentEvent(eventSelected);
      } else {
        id = currentEvent.id;
      }
      const assistants = await getAssistantsByEventId(id);
      setAssistantList(assistants);
      setShowAssistantList(true);
      setShowEventList(false);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      showNotification(
        "Ha ocurrido un error consultando los usuarios en el servidor",
        "error"
      );
    }
  };

  const handleNewEvent = () => {
    setNewEvent(true);
    setShowEventList(false);
    setShowAssistantList(false);
  };

  // eslint-disable-next-line
  const value = useMemo(() => {
    return {
      loading,
      setLoading,
      events,
      showEventList,
      setShowEventList,
      currentEvent,
      handleSelectEvent,
      newEvent,
      setCurrentEvent,
      showAssistantList,
      setShowAssistantList,
      handleSelectAssistantEvent,
      assistanList,
      handleNewEvent,
      setEvents,
      getEventsInit,
    };
  });

  return <AdminContext.Provider value={value} {...props} />;
}

export function useAdmin() {
  const context = React.useContext(AdminContext);
  if (!context) {
    throw new Error("useAdmin debe estar dentro del proveedor AdminContext");
  }
  return context;
}
